<div>
  <router-outlet></router-outlet>
  <!-- <app-responsive-helper></app-responsive-helper> -->
  <ngx-sonner-toaster [theme]="themeService.isDark ? 'dark' : 'light'"></ngx-sonner-toaster>
</div>